module.exports = __webpack_public_path__ + "media-mix-modelling-4-light-bg.e3160e678f97176bd58a6c789293855f.svg";